import { QuestionWithDetailsPresenter } from '@/forms/components/presenters/QuestionWithDetailsPresenter';
import {
  FormFieldType,
  type FormField,
  type QuestionWithDetailsFormField,
} from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildQuestionWithDetailsInitialState } from './initialState';

export const questionWithDetailsFieldModule: FormFieldModule = {
  type: FormFieldType.QuestionWithDetails,
  Presenter: ({ field, disabled }) => (
    <QuestionWithDetailsPresenter
      field={field as QuestionWithDetailsFormField}
      disabled={disabled}
    />
  ),
  flattenLeaves: (field, ctx) => {
    const f = field as QuestionWithDetailsFormField;
    const questionFields: FormField[] = [];
    if (f.trueDetails) {
      questionFields.push(f.trueDetails);
    }
    if (f.falseDetails) {
      questionFields.push(f.falseDetails);
    }
    if (f.matchingDetails) {
      questionFields.push(f.matchingDetails);
    }
    return ctx.recurse(questionFields);
  },
  buildInitialState: buildQuestionWithDetailsInitialState,
};
